export const resetFolderToInbox = "oq4XNd";
export const windowTitleModuleUserFormatString = "LJemPe";
export const mailModuleTitle = "r2x6ad";
export default {resetFolderToInbox,windowTitleModuleUserFormatString,mailModuleTitle};